import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { useMsal } from "@azure/msal-react";
import { Box, CircularProgress, Typography } from "@mui/material";
import PrimarySelect from "../../../Inputs/PrimarySelect/PrimarySelect";
import CarrierProfileScorecardItem from "./CarrierProfileScorecardItem/CarrierProfileScorecardItem";
import { CarrierService } from "../../../../services/CarrierService";
import { AlertContext } from "../../../Dashboard/Dashboard";

export default function CarrierProfileScorecard({ activeCarrier }) {
  const { instance } = useMsal();
  const { warning } = useContext(AlertContext);
  const [scorecardData, setScorecardData] = useState({});
  const [daysBack, setDaysBack] = useState(30);
  const [isLoading, setIsLoading] = useState(false);

  const scorecardItems = [
    {
      label: "Orders",
      value: scorecardData?.orderCount
    },
    {
      label: "On Time Pickup",
      value: `${Math.round(scorecardData?.onTimePickup)}%`
    },
    {
      label: "On Time Delivery",
      value: `${Math.round(scorecardData?.onTimeDelivery)}%`
    },
    {
      label: "Bounce Count",
      value: scorecardData?.bounceCount
    },
    {
      label: "Bounce %",
      value: `${Math.round(scorecardData?.bounce)}%`
    },
    {
      label: "Same Day Bounce %",
      value: `${Math.round(scorecardData?.sameDayBounce)}%`
    },
    {
      label: "Tech Tracking",
      value: `${Math.round(scorecardData?.techTracking)}%`
    }
  ];

  const selectDaysOptions = [
    {
      label: "Last 30 days",
      value: 30
    },
    {
      label: "Last 60 days",
      value: 60
    },
    {
      label: "Last 90 days",
      value: 90
    },
  ];

  useEffect(() => {
    if (activeCarrier?.id) {
      setIsLoading(true);
  
      CarrierService.GetCarrierScorecard(instance, activeCarrier.id, daysBack).then(res => {
        setScorecardData(res);
        setIsLoading(false);
      }).catch(error => {
        console.error(error);
        setIsLoading(false);
        warning(error);
      });
    }

  }, [activeCarrier, daysBack]);

  return (
    <Box>
      <Box>
        <Typography variant="subhead1" color="black_opacity.100" sx={{ marginRight: "8px" }}> 
          Performance from:
        </Typography>
        <PrimarySelect 
          id="carrier-scorecard-days-select"
          options={selectDaysOptions}
          onChange={setDaysBack}
          value={daysBack}
          nameKey="label"
          valueKey="value"
          variant="standard"
        />
      </Box>
      {isLoading ? (
        <Box sx={{ margin: "12px" }}>
          <CircularProgress sx={{ color: "primary.60" }} size={22} />
        </Box>
      ) : (
        <Box sx={{ display: "flex", flexWrap: "wrap" }}>
          {scorecardItems.map((item) => (
            <CarrierProfileScorecardItem 
              key={item.label}
              item={item}
            />
          ))}
        </Box>
      )}
    </Box>
  );
}

CarrierProfileScorecard.propTypes = {
  activeCarrier: PropTypes.object.isRequired
};